<script lang="ts">
    export let color = '#2A2727';
    export let width = 15;
    export let height = 15;
    export let strokeWidth = 1.2;
</script>

<svg {width} {height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="M13 1L1 13" stroke={color} stroke-width={strokeWidth} stroke-linecap="round" />
        <path d="M1 1L13 13" stroke={color} stroke-width={strokeWidth} stroke-linecap="round" />
    </g>
</svg>
